import { random } from 'lodash';

export default {
  getTemplates: state => state.templateList,
  getBusinessList: state => state.businessList,
  getTargetNo: state => state.targetNo,
  getEnum: state => state.enum,
  getDynamicLink: state => state.dynamicLink,
  getAudio: state => {
    return state.audio;
  },
  getAudioPlayer: state => {
    return state.audioPlayer;
  },

  getBible: state => {
    const shuffled = state.bibleList.sort(() => Math.random() - 0.5);
    return shuffled.length ? shuffled[0] : null;
  },

  getMuted: state => state.muted,
  getFeatureFlags: state => state.featureFlags,
  isFeatureFlagsLoaded: state => state.featureFlagsLoaded
};
